export enum CalendarViewMode {
  DAY = "day",
  WEEK = "week",
  SCHEDULE = "schedule",
}

export enum CalendarColorMode {
  BY_SERVICE = "BY_SERVICE",
  BY_PROVIDER = "BY_PROVIDER",
}

/** Who booked an appointment, for the calendar's "Booked By" filter. */
export enum CalendarBookingSource {
  ALL = "ALL",
  /** The patient booked it themselves through online booking. */
  ONLINE = "ONLINE",
  /** A staff member booked it. */
  STAFF = "STAFF",
}
